<template>
  <v-container text-xs-center>
    <v-layout
      row
      wrap
      style="align-items: center"
    >
      <v-btn
        flat
        icon
        color="primary"
        @click="goBack()"
      >
        <v-icon>
          $vuetify.icons.arrowLeftIcon
        </v-icon>
      </v-btn>
      <v-btn
        flat
        icon
        color="primary"
        @click="goBack()"
      >
        Voltar
      </v-btn>
    </v-layout>
    <v-card
      flat
      class="mx-auto animated fadeIn delay-1s pa-2 pb-5 mb-3"
    >
      <v-layout />
      <v-layout>
        <v-flex class="alignment mb-3">
          <h5 class="product-reference mt-1">
            {{ product.reference }} -
            {{ sortedSKUSizes }}
          </h5>
          <h4 class="text-uppercase product-name mt-1">
            {{ product.descricaoCurta }}
          </h4>
          <h5
            v-show="product.preco"
            class="product-price mt-1"
          >
            <s v-if="getStoreSkuPrice(product, 'old')">
              {{ getStoreSkuPrice(product, 'old') | currency }}
            </s>
            <span v-if="product.skus">
              {{ (getStoreSkuPrice(product, 'regular') || product.preco) | currency }}
            </span>
          </h5>
        </v-flex>
      </v-layout>
      <v-layout class="d-flex justify-center">
        <v-flex md4>
          <v-carousel
            hide-delimiters
            :cycle="false"
            height="auto"
          >
            <v-carousel-item
              v-for="(item, i) in product.imagens"
              :key="i"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <v-img
                contain
                :src="item"
                aspect-ratio=".9"
                :class="{ imageResize: $vuetify.breakpoint.mdAndUp }"
              >
                <v-toolbar
                  flat
                  light
                  height="40px"
                  class="toolbar"
                >
                  <v-toolbar-title>
                    <span
                      v-show="product.mainImage == item"
                      class="pl-3"
                      text-align-center
                    >IMAGEM PRINCIPAL</span>
                  </v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-btn
                      icon
                      @click="setMainImage(product, item)"
                    >
                      <v-icon
                        :color="item != product.mainImage ? 'grey' : 'primary'"
                      >
                        mdi-bookmark
                      </v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
              </v-img>
            </v-carousel-item>
          </v-carousel>
        </v-flex>
      </v-layout>
      <v-card-actions class="justify-center mx-0 mt-2">
        <v-btn
          slot="activator"
          block
          color="#FFADDE"
          class="primary-btn"
          style="align-items: center"
          @click="addToCatalogueAndGoPersonalize()"
        >
          <v-icon
            left
          >
            $vuetify.icons.cartIcon
          </v-icon>
          Adicionar
        </v-btn>
      </v-card-actions>
      <v-card-actions class="justify-center mx-0 pt-0">
        <v-btn
          slot="activator"
          block
          color="primary"
          class="button primary-btn"
          style="align-items: center"
          @click="addToCatalogueAndGoCart()"
        >
          Adicionar e ir ao carrinho
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { APIService } from '@/resources/campanha.js';
import { everything } from '@sejazipper/layer-api-client';
import { EventBus } from '@/event-bus.js';
import { useZipperApi } from '../composables/useZipperApi';

const api = new APIService();
const { client } = useZipperApi();

export default {
  data: () => ({
    product: {},
  }),
  computed: {
    ...mapGetters(['getStore', 'getCustomer']),

    sortedSKUSizes() {
      const weight = new Map([
        ['XPP', 1],
        ['PP', 2],
        ['XS', 3],
        ['P', 4],
        ['S', 5],
        ['M', 6],
        ['G', 7],
        ['EG', 8],
        ['L', 9],
        ['GG', 10],
        ['XG', 11],
        ['GGG', 12],
      ]);

      if (this.product.skus) {
        const sortedSizes = [...this.product.skus.map((sku) => sku.size)];

        sortedSizes.sort((a, b) => {
          const isANumber = !isNaN(Number(a));
          const isBNumber = !isNaN(Number(b));

          if (isANumber && isBNumber) {
            return Number(a) - Number(b);
          }

          if (isANumber) {
            return -1;
          }

          if (isBNumber) {
            return 1;
          }

          const weightA = weight.get(a);
          const weightB = weight.get(b);

          if (weightA !== undefined && weightB !== undefined) {
            return weightA - weightB;
          }

          if (weightA !== undefined) {
            return -1;
          }

          if (weightB !== undefined) {
            return 1;
          }

          return b.localeCompare(a, 'en', { numeric: true });
        });
        return sortedSizes.join(', ');
      }
      return 'N/A';
    },
  },
  watch: {
    async getStore(store) {
      if (store) {
        await this.getProduct();
      }
    },
  },
  mounted() {
    this.getProduct();
  },
  methods: {
    async setMainImage(product, image) {
      this.product.mainImage = image;
      if (this.getCustomer.id === '5e8fb3bc454d620004792371') {
        const adidas = ['5f637f1e5e9f1600030a6319', '5f637eac5e9f1600030a62b7'];
        adidas.forEach(async (id) => {
          await api.setProductMainImage(product, image, id);
        });
      }
      await api.setProductMainImage(product, image);
      await this.getProduct();
    },
    async getProduct() {
      const product = await client.chain.query
        .productByCustomerAndStoreAndProductId({
          customerId: this.getCustomer.id,
          storeId: this.getStore.id,
          productId: this.$route.params.id,
        })
        .get({
          ...everything,
          skus: { ...everything },
        });
      this.product = product;
    },
    emitSnackbar() {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = 'Adicionado ao catálogo com sucesso';
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },
    addToCatalogue() {
      this.$store.dispatch('clearCheckout');
      this.$store.dispatch('addToCatalogue', this.product);
      this.emitSnackbar();
    },
    addToCatalogueAndGoPersonalize() {
      this.addToCatalogue();
      this.$router.push('/personalizar');
    },
    addToCatalogueAndGoCart() {
      this.addToCatalogue();
      this.$router.push('/catalogo');
    },
    getStoreSkuPrice(product, priceType) {
      const skuByStore = product.skus.find((sku) => sku.idLoja === this.getStore.id && sku.currentStock > 0) || {};

      const prices = {
        old: skuByStore.oldPrice,
        regular: skuByStore.price,
      };

      return prices[priceType];
    },
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style scoped>
body {
  background: #e8eeff;
}

.image-style {
  border-radius: 4px;
}
.product-reference {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #433D4E;
}
.v-carousel {
  -webkit-box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%);
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 0px 0px 0px rgb(0 0 0 / 12%);
}

.alignment {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  text-align: start;
}

.imageResize {
  height: 100%;
  width: 100%;
}
.product-name {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  color: #140C22;
}
.toolbar {
  background-color: #F9F9F9;
}
.product-price {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 30px;
  color: #0C4439;
}
.primary-btn {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #140C22;
  border-radius: 7px !important;
  height: 46px;
  text-transform: none;
}
</style>
